import styled from "styled-components";

const RecommendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  margin-top: 12px;

  h2 {
    width: 100%;
    text-align: left;
    color: #000000;
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 16px 0;
  }
`;

const FlowerItem = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-right: 8px;
  cursor: pointer;

  div {
    background-color: #FFF8F0;
    border-radius: 20px;
    font-size: 0.875rem;
    padding: 8px 12px;
    color: #FF7A00;
    text-align: center;
  }
`;

export { RecommendWrapper, FlowerItem };